<template>
  <li>
    <i class="fa fa-file" />
    <span :title="content.basename">{{ content.basename }}</span>
    <i class="fa fa-link" @click="attachFile" />
  </li>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      required: true,
    },
  },

  methods: {
    attachFile() {
      this.$emit('attach-file', this.content.url);
    },
  },
};
</script>

<style scoped>
  li {
    display: flex;
    position: relative;
    width: 100%;
    margin-top: 5px;
    list-style-type: none;
  }
  span {
    max-width: calc(100% - 10px);
    margin: 0 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .fa-link {
    cursor: pointer;
  }
  .fa-file {
    line-height: 20px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// File.vue?1522bca1